import React, { Component } from 'react';

export default class Descricao extends Component {
    render(){
        return (
            <div className="Descricao">
                <div className="container flex horizontal">
                    <div className="flex-1">
                        {/* <h3 className="text-center">Descricao</h3>
                        <br /> */}
                        <div className="flex vertical descricao">
                            <div className="padding-20">
                                <h3 className="text-center">Cabo premium de alta qualidade, carrega até três dispositivos ao mesmo tempo</h3>
                            </div>
                            <div>
                                <h3 className="text-center">Cabo USB 3-em-1</h3>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1">
                        <h3 className="text-center">Especificações</h3>
                        <br />
                        <div className="flex vertical especificacoes">
                            <div className="flex-1 flex horizontal-only">
                                <div className="flex-1 flex flex-center border-top-left">
                                    <span>Tipo de cabo</span>
                                </div>
                                <div className="flex-2 flex flex-center border-top-right">
                                    <span>USB 2.0 x V8 Micro USB x Tipo-C x Iphone 5/6/7</span>
                                </div>
                            </div>
                            <div className="flex-1 flex horizontal-only">
                                <div className="flex-1 flex flex-center">
                                    <span>Comprimento</span>
                                </div>
                                <div className="flex-2 flex flex-center no-left-border">
                                    <span>1 metro</span>
                                </div>
                            </div>
                            <div className="flex-1 flex horizontal-only">
                                <div className="flex-1 flex flex-center border-bottom-left">
                                    <span>Material</span>
                                </div>
                                <div className="flex-2 flex flex-center border-bottom-right">
                                    <span>TPE</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}